export const getOrigin = () => {
  if (typeof window === 'undefined' || !window.location) {
    return undefined
  }

  return window.location.origin.replace(/\/$/, '')
}
